import type { FC, HTMLAttributes, Ref, RefObject } from 'react'
import React, { useRef } from 'react'
import ReactDraggable from 'react-draggable'

export interface DraggableProps {
  className?: string
  children: React.ReactNode
}

const Container = ({ ref, ...props }: HTMLAttributes<HTMLDivElement> & { ref?: Ref<HTMLDivElement> }) => (
  <div ref={ref} {...props} style={{ display: 'flex', ...props.style }} />
)

const Handle = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} style={{ cursor: 'grab', display: 'flex', flex: 1, ...props.style }} />
)

export const Draggable: FC<DraggableProps> = props => {
  const { className, children } = props
  const handleMouse = (ev: globalThis.MouseEvent) => ev.preventDefault()
  const containerRef = useRef<HTMLDivElement | null>(null)

  return (
    <ReactDraggable handle="div" nodeRef={containerRef as RefObject<HTMLElement>} onMouseDown={handleMouse}>
      <Container className={className} ref={containerRef}>
        <Handle>{children}</Handle>
      </Container>
    </ReactDraggable>
  )
}

export default Draggable
